import {ButtonUnstyled, styled} from '@mui/material';

export const OutlinedButton = styled(ButtonUnstyled)(({theme}) => ({
  border: '1px solid #0000001A',
  borderRadius: '12px',
  padding: theme.typography.pxToRem(12),
  background: 'none',
  width: '100%',
  cursor: 'pointer',
  color: '#1F2A37',
  fontSize: theme.typography.pxToRem(14),
  fontFamily: theme.typography.button.fontFamily,
  transition: 'background 0.2s ease-in-out',
  '&:hover': {
    background: '#00000008',
  },
  '&:disabled': {
    background: theme.palette.action.disabledBackground,
    cursor: 'not-allowed',
  },
}));
